import { render, staticRenderFns } from "./BasicFormGroup.vue?vue&type=template&id=1ad6c8f0&scoped=true&"
import script from "./BasicFormGroup.vue?vue&type=script&lang=js&"
export * from "./BasicFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./BasicFormGroup.vue?vue&type=style&index=0&id=1ad6c8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad6c8f0",
  null
  
)

export default component.exports